import { AutoComplete, Input } from "antd";
import { useIntl } from "react-intl";

import { useTicketTemplateSelect } from "./hooks";
import { TicketTemplateSelectProps } from "./types";

const TicketTemplateSelect: React.FC<TicketTemplateSelectProps> = (props) => {
  const intl = useIntl();
  const ticketTemplateSelect = useTicketTemplateSelect(props);

  return (
    <AutoComplete {...ticketTemplateSelect}>
      <Input.Search
        placeholder={intl.formatMessage({
          defaultMessage: "Choose ticket template",
        })}
      />
    </AutoComplete>
  );
};

export default TicketTemplateSelect;
